import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './style.scss';

/**
 * @callback clickCallbackCb
 */

/**
 * Page number
 * @param {number} number
 * @param {number} isCurrentPage
 * @param {clickCallbackCb} clickCallback
 * @returns {JSX.Element}
 */

const PageNumber = ({number, isCurrentPage, clickCallback}) => {
  
  const handleClick = () => {
    if (!isCurrentPage) {
      clickCallback(number);
    }
  }

  return(
    <a className={`page_numbers__page ${isCurrentPage ? "page_numbers__page--current" : ""}`} key={number} onClick={handleClick} aria-label={`Page ${number}`}>
      {number}
    </a>
  );
}


/**
 * @callback updatePageCb
 */

/**
 * Pagination
 * @param {number} currentPage
 * @param {number} totalRecords
 * @param {number} pageLimit
 * @param {updatePageCb} updatePage
 * @returns {JSX.Element}
 */

const Pagination = ({currentPage, totalRecords, pageLimit, updatePage}) => {
  const totalPages = Math.ceil(totalRecords / pageLimit);  
  const startPage = (currentPage === totalPages && totalPages > 1) ? currentPage - 2 : currentPage - 1;
  const endPage = (currentPage === 1 && totalPages > 1) ? currentPage + 2 : currentPage + 1;
  
  let pageNumbers = [];
  for (let index = startPage; index <= endPage; index++) {
    if (index > 0 && index <= totalPages) {
      pageNumbers.push(<PageNumber key={index} number={index} isCurrentPage={index === currentPage} clickCallback={updatePage}></PageNumber>);
    }
  }

  return (
    <div className="pagination">            
      <div className="pagination__next_prev">
        {(currentPage - 1) > 0 && (            
          <a onClick={() => updatePage(currentPage - 1)} aria-label="Previous Page">Previous</a>
        )}
      </div>
      <div className="pagination__page_numbers">
        { pageNumbers }
      </div>
      <div className="pagination__next_prev">
        {(currentPage + 1) <= totalPages && (            
          <a onClick={() => updatePage(currentPage + 1)} aria-label="Next Page">Next</a>
        )}        
      </div>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number,
  totalRecords: PropTypes.number,
  pageLimit: PropTypes.number,
  updatePage: PropTypes.func,
};

export default Pagination;
